import { GameAsset } from '../../services/asset-catalogue-service';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { PileView } from './pile-view';
import { WastePileViewModel } from './waste-pile-view-model';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class WastePileView extends PileView {
  private get wasteViewModel(): WastePileViewModel {
    return this.viewModel as WastePileViewModel;
  }

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: WastePileViewModel) {
    super(scene, x, y, viewModel);
  }

  protected override resizeBackground(
    gameSizeMetrics: GameSizeMetrics,
    gameAsset: GameAsset,
  ): void {
    const layoutConfig = this.viewModel.layoutConfig;
    const calc = this.viewModel.calculateScaleFactor(gameSizeMetrics);

    let xPos = (gameSizeMetrics.widthDpr - calc.totalWidth * calc.scaleFactor) * 0.5;
    xPos += (gameAsset.dimensions.width + layoutConfig.hSpacing) * 4.5 * calc.scaleFactor;
    const yPos = layoutConfig.vPadding * calc.scaleFactor;

    this.background.setPosition(xPos, yPos);
    this.background.setDisplaySize(
      gameAsset.dimensions.width * calc.scaleFactor,
      gameAsset.dimensions.height * calc.scaleFactor,
    );
  }
}
